var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"h4 text-white px-2 py-2 pr-6"},[_vm._t("default",function(){return [_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }